import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

async function deleteServiceDocument(axios: AxiosInstance, serviceDocumentId: number | undefined) {
  return axios.delete(`${config.apiBaseUrl}/op/v1/document/${serviceDocumentId}`);
}

export default function useDeleteServiceDocumentMutation(serviceDocumentId: number | undefined) {
  const axios = useAxios();

  return useMutation({ mutationFn: () => deleteServiceDocument(axios, serviceDocumentId) });
}
